import { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import StandardButton from 'design-system/Buttons/StandardButton'
import DollarSign from 'design-system/Iconography/SVG/DollarSign'
import Headphone from 'design-system/Iconography/SVG/HeadSet'
import PointerEmphasis from 'design-system/Iconography/SVG/PointerEmphasis'
import { Grid, GridItem } from 'design-system/Layouts/Grid'
import Body2 from 'design-system/Typography/Body/Body2'
import Heading1 from 'design-system/Typography/Heading/Heading1'
import Subheading1 from 'design-system/Typography/Subheading/Subheading1'
import Title1 from 'design-system/Typography/Title/Title1'

import BackgroundImage from 'components/BackgroundImage'
import Spacer from 'components/Spacer'
import ViewportMarginContainer from 'components/ViewportMarginContainer'

const Background = styled.div`
  background-color: ${props => props.theme.colors.neutral25};
`

const HeadingContainer = styled.div`
  width: 80%;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    width: 420px;
  }
`

const Br = styled.div`
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    display: none;
  }
`

const ContentLayout = styled.div`
  margin-top: -50px;
`

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: ${props => props.theme.colors.gold600};
  border: 4px solid ${props => props.theme.colors.white};
  border-radius: 50%;
  margin: 0 auto;
`

const Hero = () => {
  const theme = useContext(ThemeContext)
  return (
    <Background>
      <BackgroundImage
        backgroundSize="cover"
        imgSrc={`${process.env.CDN_BASE_URL}/q_auto,c_crop,w_0.5,h_0.5,x_0.2,y_0.21,g_south_west/amazon/assets/how-it-works/women-thinking-of-selling-homes-online.jpg`}
        imgSrcTablet={`${process.env.CDN_BASE_URL}/q_auto,c_crop,w_0.8,h_0.5,y_0.21,g_south_west/amazon/assets/how-it-works/women-thinking-of-selling-homes-online.jpg`}
        imgSrcDesktop={`${process.env.CDN_BASE_URL}/q_auto,c_crop,w_1,h_0.5,y_0.3/amazon/assets/how-it-works/women-thinking-of-selling-homes-online.jpg`}
      >
        <Spacer
          size={theme.spacings[72]}
          tabletSize={100}
          desktopSize={theme.spacings[120]}
        />
        <ViewportMarginContainer>
          <HeadingContainer>
            <Heading1 color="white">
              You Sell. <Br /> We Help. <Br /> You Save Big.
            </Heading1>
            <Subheading1 color="white">Pay for the work we do and nothing else.</Subheading1>
          </HeadingContainer>
        </ViewportMarginContainer>
        <Spacer
          size={theme.spacings[72]}
          tabletSize={100}
          desktopSize={theme.spacings[120]}
        />
      </BackgroundImage>
      <ViewportMarginContainer>
        <ContentLayout>
          <Grid
            gridColumnsMobile="1fr"
            gridColumns="1fr 1fr 1fr"
            columnGapTablet="24px"
            columnGapDesktop="42px"
            rowGap="32px"
          >
            <GridItem>
              <Circle>
                <Headphone
                  fill={theme.colors.white}
                  width={45}
                  height={45}
                />
              </Circle>
              <Spacer
                size={theme.spacings[24]}
                desktopSize={theme.spacings[32]}
              />
              <Title1 textAlign="center">Expert Help</Title1>
              <Spacer
                size={theme.spacings[16]}
                desktopSize={theme.spacings[24]}
              />
              <Body2 textAlign="center">
                Access to real estate professionals 7 days a week via phone, chat, or email.
              </Body2>
            </GridItem>
            <GridItem>
              <Circle>
                <DollarSign
                  fill={theme.colors.white}
                  width={45}
                  height={45}
                />
              </Circle>
              <Spacer
                size={theme.spacings[24]}
                desktopSize={theme.spacings[32]}
              />
              <Title1 textAlign="center">Low Flat Fees</Title1>
              <Spacer
                size={theme.spacings[16]}
                desktopSize={theme.spacings[24]}
              />
              <Body2 textAlign="center">
                Flat fees based on the amount of work we do, never a percentage of your home sale.
              </Body2>
            </GridItem>
            <GridItem>
              <Circle>
                <PointerEmphasis
                  fill={theme.colors.white}
                  width={45}
                  height={45}
                />
              </Circle>
              <Spacer
                size={theme.spacings[24]}
                desktopSize={theme.spacings[32]}
              />
              <Title1 textAlign="center">Exceptional Technology</Title1>
              <Spacer
                size={theme.spacings[16]}
                desktopSize={theme.spacings[24]}
              />
              <Body2 textAlign="center">
                Our tech platform empowers you to sell smarter and better, enabling you to keep more
                of your equity.
              </Body2>
            </GridItem>
          </Grid>
        </ContentLayout>
        <Spacer
          size={theme.spacings[32]}
          tabletSize={theme.spacings[36]}
          desktopSize={theme.spacings[48]}
        />
        <StandardButton
          type="primary"
          size="medium"
          label="Get Started"
          href="/listing/create"
          boxShadow={theme.shadows.blue.level1}
          center
        />
      </ViewportMarginContainer>
      <Spacer
        size={theme.spacings[40]}
        desktopSize={theme.spacings[48]}
      />
    </Background>
  )
}

export default Hero
